export enum EdiMessageDirection {
	Incoming = 0,
	Outgoing = 10,
}